module.exports = __webpack_public_path__ + "static/media/7D.bad15b1c.svg";